import React from 'react'
import styles from './ExecutiveSummary.module.css'

const metricIcons = {
  higher: <span role="img" aria-label="trending up">↑</span>,
  lower: <span role="img" aria-label="trending down">↓</span>
}

const ExecutiveSummaryMetrics = ({ metrics }) => {
  if (!metrics || !metrics.length) return null

  return (
    <div className={styles.metricsGrid}>
      {metrics.map((metric, idx) => {
        const current = parseFloat(String(metric.current_value || '').replace('~', ''))
        const target = parseFloat(String(metric.target_value || '').replace('~', ''))
        const higher = metric.direction === 'higher_is_better'
        const onTrack = higher ? current >= target : current <= target
        const pct = higher
          ? Math.min(100, Math.round((current / target) * 100))
          : Math.min(100, Math.round((target / current) * 100))

        return (
          <div key={idx} className={styles.metricCard}>
            <div className={styles.metricHeader}>
              <div className={styles.metricTitleSection}>
                <div className={styles.metricIcon}>{metricIcons[higher ? 'higher' : 'lower']}</div>
                <div>
                  <div className={styles.metricName}>{metric.name}</div>
                  <div className={styles.metricDirection}>{higher ? 'Higher is better' : 'Lower is better'}</div>
                </div>
              </div>
              <span
                className={styles.tag}
                style={{
                  backgroundColor: onTrack ? '#f6ffed' : '#fff1f0',
                  color: onTrack ? '#52c41a' : '#f5222d'
                }}
              >
                {onTrack ? 'ON TRACK' : `Δ ${metric.delta}`}
              </span>
            </div>

            <div className={styles.metricValues}>
              <div className={styles.metricValueSection}>
                <div className={styles.metricLabel}>Current</div>
                <div className={styles.metricNumber}>
                  {metric.current_value}
                  {metric.unit && <span className={styles.metricUnit}>{metric.unit}</span>}
                </div>
              </div>
              <div className={styles.metricValueSection}>
                <div className={styles.metricLabelArrow}><span role="img" aria-label="arrow">→</span></div>
              </div>
              <div className={styles.metricValueSection}>
                <div className={styles.metricLabel}>Target</div>
                <div className={styles.metricNumber} style={{ color: onTrack ? '#52c41a' : '#f5222d' }}>
                  {metric.target_value}
                  {metric.unit && <span className={styles.metricUnit}>{metric.unit}</span>}
                </div>
              </div>
            </div>

            <div className={styles.progressContainer}>
              <div className={styles.progressBarBg}>
                <div
                  className={styles.progressBarFill}
                  style={{ width: `${pct}%`, backgroundColor: onTrack ? '#52c41a' : '#f5222d' }}
                />
              </div>
              <div className={styles.progressText}>
                <span className={styles.progressTextLeft}>✓ {pct}% of target</span>
                <span style={{ color: onTrack ? '#52c41a' : '#f5222d' }}>
                  Gap: {metric.delta} {metric.unit}
                </span>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default ExecutiveSummaryMetrics
